import React from 'react';

export default function HintWarranty({ hint = '' } ) {
    const { info = '', img = '', href = '', linkText = '' } = hint;
    return (
        <div className={'hint'}>
            <div className={'hint__label'}>?</div>
            <div className={'hint__elem'}>
                {img ? <img src={img} alt=""/> : ''}
                <span>{info} {href ? <a href={href}>{linkText}</a> : ''}</span>
            </div>
        </div>
    )
};
